export { Accordion } from 'features/ContactSidebar/Accordion/Accordion';
export type { AccordionProps } from 'features/ContactSidebar/Accordion/Accordion.types';
